const otherControlSelector = [
  'button',
  'a[href]',
  'input',
  'select',
  'textarea',
  '[contenteditable="true"]',
  '[role="button"]',
  '[role="link"]',
  '[role="menuitem"]',
  '[role="option"]',
].join(', ')

/**
 * Enter sends the composer message from a window listener. When another
 * control has focus (a composer icon button, a link, a search field), Enter
 * belongs to that control instead.
 */
export const isEnterForAnotherControl = (
  target: EventTarget | null,
  composer: Element | null,
) =>
  target instanceof Element &&
  target !== composer &&
  target.closest(otherControlSelector) !== null
